import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Minibusonrentinmumbai() {



const cardData = {
  keyword: " Mini Bus on Rent in Mumbai",

headingDescription:
  "Omshree Cab offers dependable and spacious mini bus on rent in Mumbai for travelers who need comfortable group transportation for large family outings, school or college trips, corporate events, weddings, pilgrimages, or outstation journeys. Our mini buses are ideal for groups of 15, 20, 25, or more passengers, providing ample seating, generous luggage space, and air‑conditioned comfort throughout your trip. We offer flexible rental options including one‑way rides, round trips, hourly rentals, full‑day packages, and long‑distance travel plans with transparent pricing and no hidden charges. Each mini bus in our fleet is well‑maintained, regularly serviced, and driven by professional chauffeurs experienced with Mumbai’s roads and traffic patterns. With easy online booking, punctual pickups from any location in Mumbai (including airports, railway stations, hotels, and residential areas), and 24/7 customer support, renting a mini bus in Mumbai is convenient, comfortable, and stress‑free for all your group travel needs.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks overlooking the Arabian Sea and a must‑visit spot for tourists. The historic arch monument attracts visitors for photography, sightseeing, and ferry rides to Elephanta Island. The Colaba area surrounding the Gateway also features heritage buildings, cafes, and vibrant street markets. Renting a mini bus makes it easy and comfortable for large groups to visit this popular destination together without the hassle of arranging multiple vehicles or dealing with parking challenges."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal boulevard stretching along the Arabian Sea, famously known as the Queen’s Necklace because of the streetlights that sparkle at night. Visitors enjoy evening walks, breathtaking sunset views, and relaxed drives along the promenade. A rented mini bus allows large groups to travel together comfortably while exploring the iconic route, making frequent stops for photos or sightseeing along the way."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beaches, known for its sandy shores, sea breeze, and vibrant street food culture featuring pav bhaji, bhel puri, and pani puri. Families, friends, and tourists visit to relax, take sunset photographs, and enjoy seaside snacks. Renting a mini bus ensures ample seating and space for everyone, making it a great option for group trips to this lively beach destination."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a well‑known Hindu temple in Mumbai dedicated to Lord Ganesha, attracting devotees from all over the country. The temple’s peaceful atmosphere and spiritual significance make it a major attraction for pilgrims and tourists alike. Festivals like Ganesh Chaturthi draw large crowds. A mini bus rental provides spacious and comfortable group transport, avoiding the challenges of crowded local vehicles or parking near this popular spiritual site."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is a modern cable‑stayed bridge connecting Bandra and Worli across the Arabian Sea. The route offers spectacular views of the sea and city skyline, especially during sunset and at night when the lights illuminate the bridge. Large groups traveling in a mini bus can enjoy this scenic drive together, with plenty of space for everyone and the ability to stop for photos or sightseeing along the way."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous mosque and shrine situated on a small island off the coast of Mumbai, connected to the mainland by a narrow walkway that becomes visible during low tide. The shrine attracts visitors from diverse backgrounds who come to offer prayers and enjoy the tranquil atmosphere. Renting a mini bus ensures comfortable group transport to this spiritual site while avoiding the challenges of city traffic and parking constraints."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves located on Elephanta Island that showcase intricate stone carvings dedicated to Lord Shiva. Recognized as a UNESCO World Heritage Site, the caves attract tourists interested in history, art, and architecture. Visitors typically take a ferry from the Gateway of India to reach the island. Renting a mini bus provides ample seating for large groups to reach the ferry point together comfortably and begin the cultural excursion without transport hassles."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large forest reserve within Mumbai offering trekking, wildlife spotting, nature walks, and the historic Kanheri Caves. Nature lovers and families visit this green oasis to enjoy outdoor activities and scenic trails. Renting a mini bus ensures plenty of seating and space for gear, making it ideal for full‑day group trips to this natural attraction while keeping everyone together."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a vibrant shopping street in South Mumbai filled with markets, boutiques, cafes, and local vendors. Visitors can explore eclectic stalls selling clothes, accessories, handicrafts, and souvenirs. The lively street also has many eateries where groups can enjoy local cuisine. A mini bus rental allows large groups to reach this bustling marketplace comfortably and integrate it into a full day of sightseeing."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraces on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors come here for peaceful walks, photography, and nature relaxation. Renting a mini bus provides convenient and comfortable transport for large groups to visit this scenic location as part of their group sightseeing itinerary."
  }
],



services: [
{
name: "Mini Bus on Rent Mumbai",
description: "Mini bus on rent in Mumbai provides comfortable group transportation for passengers traveling together for tours, events, and corporate trips. Mini buses are designed with spacious seating and smooth ride quality suitable for both city travel and highway journeys. Professional drivers ensure punctual pickup and safe driving across Mumbai and nearby destinations. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family tours, school trips, and corporate outings. Air-conditioned interiors ensure comfortable journeys for passengers. Flexible booking options allow convenient reservations anytime."
},
{
name: "Mini Bus Rental Mumbai",
description: "Mini bus rental in Mumbai offers reliable group travel solutions for passengers planning comfortable transportation. These buses provide spacious seating capacity and smooth performance suitable for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs across the city. Ideal for family trips, company outings, and tourist groups. Large luggage space ensures convenient travel for passengers. Flexible rental options allow easy scheduling of trips."
},
{
name: "Mini Bus Hire Mumbai",
description: "Mini bus hire in Mumbai provides convenient group transportation for passengers traveling within the city or planning outstation tours. Mini buses offer comfortable seating arrangements and smooth highway performance. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for wedding guests, family tours, and business travel groups. Spacious interiors ensure comfortable journeys. Flexible hiring options allow easy ride planning."
},
{
name: "Mini Bus Cab Service Mumbai",
description: "Mini bus cab service in Mumbai provides dependable group transportation for passengers traveling together for events and tours. These vehicles offer spacious seating and comfortable interiors suitable for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for family travel, corporate outings, and school trips. Large luggage capacity ensures convenient group travel. Flexible booking options allow quick and easy reservations."
},
{
name: "25 Seater Bus Rental Mumbai",
description: "25 seater bus rental in Mumbai offers spacious transportation for medium-sized groups traveling together. These buses provide comfortable seating, smooth ride quality, and reliable highway performance. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, and railway stations. Ideal for corporate travel, family tours, and school excursions. Air-conditioned interiors ensure comfortable journeys for passengers. Flexible rental options allow convenient travel planning."
},
{
name: "32 Seater Bus Hire Mumbai",
description: "32 seater bus hire in Mumbai provides large group transportation with spacious seating and comfortable travel experience. These buses are designed for smooth long-distance travel and group tours. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for corporate events, wedding guest transport, and tourist groups. Spacious interiors ensure comfortable seating for passengers. Flexible booking options allow convenient reservations."
},
{
name: "Mini Bus for Corporate Travel Mumbai",
description: "Mini bus for corporate travel in Mumbai offers reliable group transportation for company employees and business teams. These buses provide comfortable seating and smooth travel suitable for professional trips and office outings. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from offices, hotels, airports, and business districts. Ideal for corporate events, conferences, and team outings. Spacious interiors ensure comfortable travel for employees. Flexible booking options allow scheduled corporate trips."
},
{
name: "Mini Bus Airport Transfer Mumbai",
description: "Mini bus airport transfer in Mumbai provides convenient group transportation to and from airport terminals. These buses offer spacious seating and luggage capacity suitable for passengers traveling with baggage. Professional drivers monitor flight schedules to ensure punctual pickup and drop services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourist groups, corporate teams, and family airport transfers. Comfortable AC interiors ensure relaxed journeys. Flexible booking options allow advance reservations."
},
{
name: "Mini Bus for Group Travel Mumbai",
description: "Mini bus for group travel in Mumbai provides spacious transportation for passengers traveling together on tours and outings. These buses offer comfortable seating and smooth ride quality suitable for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, and railway stations. Ideal for group sightseeing, family trips, and school tours. Large luggage capacity ensures convenient travel. Flexible booking options allow easy travel planning."
},
{
name: "Mini Bus for Wedding Mumbai",
description: "Mini bus for wedding in Mumbai provides convenient transportation for wedding guests and family members. These buses offer spacious seating and comfortable travel suitable for transporting large groups between venues. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, and wedding venues. Ideal for wedding functions, receptions, and guest transfers. Comfortable interiors ensure relaxed journeys. Flexible booking options allow easy reservations."
},
{
name: "Mini Bus Tour Rental Mumbai",
description: "Mini bus tour rental in Mumbai offers comfortable transportation for sightseeing tours and tourist groups. These buses provide spacious seating and smooth highway performance for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from hotels, tourist locations, railway stations, and airport terminals. Ideal for city tours, pilgrimage trips, and holiday travel. Air-conditioned interiors ensure comfortable journeys for passengers. Flexible rental options allow convenient travel planning."
},
{
name: "Luxury Mini Bus Mumbai",
description: "Luxury mini bus in Mumbai offers premium group transportation with comfortable seating and stylish interiors. These buses provide enhanced comfort and smooth travel experience for passengers. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for VIP travel, corporate groups, and luxury tours. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow quick reservations."
},
{
name: "AC Mini Bus Mumbai",
description: "AC mini bus in Mumbai provides comfortable air-conditioned transportation for group travel across the city and nearby destinations. These buses ensure cool and relaxing journeys even during long trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family tours, corporate travel, and school trips. Spacious interiors ensure comfortable seating. Flexible booking options allow convenient ride scheduling."
},
{
name: "Mini Bus Booking Mumbai",
description: "Mini bus booking in Mumbai allows passengers to easily reserve spacious buses for group travel. Online and phone booking options provide quick ride confirmation and convenient scheduling. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family tours, corporate travel, and tourism groups. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow easy reservations anytime."
},
{
name: "Mini Bus Near Me Mumbai",
description: "Mini bus near me in Mumbai helps passengers quickly find nearby group transportation services for events and tours. These buses provide spacious seating and comfortable travel suitable for large groups. Professional drivers ensure punctual pickup and safe driving services across nearby areas in Mumbai. Pickup services are available from homes, hotels, offices, and transport hubs. Ideal for group tours, corporate travel, and wedding guest transport. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow quick reservations."
}
],

tableData: [
["Mini Bus on Rent Mumbai","Mini Bus Rental Mumbai"],
["Mini Bus Hire Mumbai","Mini Bus Cab Service Mumbai"],
["25 Seater Bus Rental Mumbai","32 Seater Bus Hire Mumbai"],
["Mini Bus for Corporate Travel Mumbai","Mini Bus Airport Transfer Mumbai"],
["Mini Bus for Group Travel Mumbai","Mini Bus for Wedding Mumbai"],
["Mini Bus Tour Rental Mumbai","Luxury Mini Bus Mumbai"],
["AC Mini Bus Mumbai","Mini Bus Booking Mumbai"],
["Mini Bus Near Me Mumbai","Mini Bus Hire Near Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Spacious Mini Bus for Group Travel",
    WhyChoosedescription: "Mini buses are ideal for group transportation in Mumbai. They offer comfortable seating and sufficient space for passengers and luggage, making them perfect for corporate trips, school outings, weddings, and family tours."
  },
  {
    WhyChooseheading: "Affordable Mini Bus Rental Pricing",
    WhyChoosedescription: "Omshree Cabs provides competitive and transparent pricing for mini bus rentals in Mumbai. Customers receive clear information about per-kilometer rates, toll charges, and travel packages before booking."
  },
  {
    WhyChooseheading: "24/7 Mini Bus Booking Service",
    WhyChoosedescription: "Our mini bus rental service in Mumbai is available 24 hours a day. Whether you need early morning transport for a group event or late-night travel, Omshree Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All mini buses in our fleet are regularly serviced, cleaned, and sanitized to provide passengers with a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Perfect for Local & Outstation Trips",
    WhyChoosedescription: "Mini buses are ideal for local sightseeing in Mumbai as well as outstation group travel to destinations like Pune, Lonavala, Nashik, Shirdi, Mahabaleshwar, and Goa."
  },
  {
    WhyChooseheading: "Professional Drivers for Group Travel",
    WhyChoosedescription: "Our trained drivers are experienced in handling mini buses and long-distance travel routes. They ensure safe driving and a smooth travel experience for groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, schools, railway stations, and airports anywhere in Mumbai so your group journey starts without hassle."
  },
  {
    WhyChooseheading: "Trusted Mini Bus Rental Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for mini bus rentals in Mumbai because of our punctual service, comfortable vehicles, and professional drivers."
  }
]
};

const faqData = [
  { question: "Do you provide mini bus on rent in Mumbai?", answer: "Yes, Omshree Cabs provides mini bus rental services in Mumbai for group travel, corporate trips, weddings, and outstation tours." },
  { question: "How many passengers can travel in a mini bus?", answer: "Mini buses typically accommodate 17 to 32 passengers depending on the vehicle type." },
  { question: "Is mini bus suitable for group travel?", answer: "Yes, mini buses are ideal for family tours, corporate outings, school trips, wedding transport, and group sightseeing." },
  { question: "Do you provide mini bus for outstation trips?", answer: "Yes, we provide mini bus rentals from Mumbai to destinations like Pune, Lonavala, Nashik, Shirdi, Mahabaleshwar, and Goa." },
  { question: "Are mini buses air-conditioned?", answer: "Yes, we provide both AC and non-AC mini buses depending on customer requirements." },
  { question: "Do you provide drivers with the mini bus?", answer: "Yes, all mini bus rentals include professional and experienced drivers." },
  { question: "Can I book mini bus for a full-day trip?", answer: "Yes, we offer full-day and multi-day mini bus rental packages in Mumbai." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, festivals, and group travel seasons." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, sightseeing, or refreshment breaks." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Kulkarni",
    feedback:
      "We booked a mini bus from Omshree Cabs for our Mumbai to Shirdi group trip. The vehicle was comfortable and the driver handled the journey very well.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback:
      "Excellent mini bus rental service in Mumbai. Perfect for our corporate team outing with clean vehicle and professional driver.",
    rating: 5
  }
];



















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus on Rent in Mumbai",
  "description": "Omshree Cab offers Mini Bus on rent in Mumbai for corporate travel, airport transfers, group trips, weddings, and city tours. Available in 25 and 32-seater options, our AC-equipped and well-maintained mini buses provide comfort, safety, and luxury. Flexible booking options and affordable rates make it ideal for group travel across Mumbai and nearby destinations.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};








  return (
    <div>
      <Helmet>
  <title>Mini Bus on Rent in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides Mini Bus on rent in Mumbai for corporate travel, airport transfers, group trips, weddings, and city tours. 25 and 32-seater options with AC, well-maintained vehicles, and flexible booking options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinmumbai;